"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityFieldArgs = exports.ENTITY_FIELD_LABELS = void 0;
var lodash_1 = require("lodash");
exports.ENTITY_FIELD_LABELS = {
  image2x: "Image (2x)",
  url: "URL",
  id: "ID"
};
/* applies standard processing and defaults to field arguments */
var entityFieldArgs = function (args) {
  var context = args.context,
    rest = __rest(args, ["context"]);
  var name = rest.name,
    label = rest.label,
    placeholder = rest.placeholder,
    description = rest.description,
    preDescription = rest.preDescription,
    postDescription = rest.postDescription,
    preLabel = rest.preLabel,
    postLabel = rest.postLabel;
  var recommended = !!args.recommended; // === undefined ? (!args.fieldSet || args.fieldSet === 'overview') : !!args.recommended;
  var ret = __assign(__assign({}, rest), {
    recommended: recommended,
    placeholder: placeholder ? placeholder : '',
    label: "".concat(preLabel ? preLabel : '').concat(label || exports.ENTITY_FIELD_LABELS[name] || (0, lodash_1.startCase)(name)).concat(postLabel ? postLabel : ''),
    description: description ? "".concat(preDescription ? preDescription : '').concat(description).concat(postDescription ? postDescription : '') : undefined
  });
  return ret;
};
exports.entityFieldArgs = entityFieldArgs;